import {ComponentFactoryResolver, Injector} from '@angular/core';
import {NzConfig} from 'ng-zorro-antd/core/config';
import {COLLAPSE_CONFIG, PAGINATION_CONFIG, SWITCH_CONFIG, TABLE_CONFIG} from './nz-common.config';
import {GlobalTemplatesComponent} from '@app/ng-zorro/nz-config/global-templates.component';

const NZ_CONFIG = {...SWITCH_CONFIG, ...COLLAPSE_CONFIG, ...PAGINATION_CONFIG};

// The Factory function
export const nzConfigFactory = (
  injector: Injector,
  resolver: ComponentFactoryResolver
): NzConfig => {
  const factory = resolver.resolveComponentFactory(GlobalTemplatesComponent);
  // const nzIndicator = factory.create(injector).instance.nzIndicator;
  // const nzEmpty = factory.create(injector).instance.nzEmpty;
  return {
    ...NZ_CONFIG,
    // spin: {
    //   nzIndicator
    // },
    table: {
      ...TABLE_CONFIG,
      // nzLoadingIndicator: nzIndicator
    },
    // empty: {
    //   nzDefaultEmptyContent: nzEmpty
    // }
  };
};
